import { CustomModelAutomaticMutationSideEffectConfigs } from "../types";

export const ENDUSER_MEDICATIONS_MUTATION_SIDE_EFFECT_CONFIGS: CustomModelAutomaticMutationSideEffectConfigs<"enduser_medications"> =
  {};
